// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__7VPZx","list":"BalanceDue_list__288eF","listRow":"BalanceDue_listRow__3qPqp","total":"BalanceDue_total__snyxf"};